import { getStatusColor, getStatusForeColor, getStatusLabel } from '@/utils';
import { Box, Stack, Typography } from '@mui/material';

export function Status({ status }) {
  if (!status) return null;

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
      <Box
        sx={{
          width: 12,
          height: 12,
          bgcolor: getStatusColor(status),
          borderRadius: 6,
          border: `1px solid ${getStatusForeColor(status) ?? 'transparent'}`,
        }}
      />
      <Typography variant="caption">{getStatusLabel(status)}</Typography>
    </Stack>
  );
}
